import { Layout as BaseLayout, LayoutProps } from 'react-admin';
import Menu from './Menu';

const Layout: React.FC<LayoutProps> = (props) => <BaseLayout {...props} menu={Menu} />;

export default Layout;
